export default [
  {
    title: { pt: "Objetivos concluídos", en: "Completed objectives" },
    subtitle: {
      pt: "Aluno ter finalizado o curso",
      en: "Student has completed the course",
    },
  },
  {
    title: { pt: "Objetos concluídos", en: "Completed objects" },
    subtitle: {
      pt: "Número total de objetos concluídos",
      en: "Total number of completed objects",
    },
  },
  {
    title: { pt: "NPS", en: "NPS" },
    subtitle: {
      pt: "Net Promoter Score é uma das métricas mais eficazes para medir a satisfação do aluno sobre o curso",
      en: "Net Promoter Score is one of the most effective metrics for measuring student satisfaction with the course",
    },
  },
  {
    title: { pt: "Média do Quiz", en: "Quiz Average" },
    subtitle: {
      pt: "Média do quiz do aluno no objetivo",
      en: "Average student quiz score in the objective",
    },
  },
  {
    title: { pt: "Taxas Médias", en: "Average Rates" },
    subtitle: {
      pt: "Média de avaliação do aluno no objetivo",
      en: "Average student evaluation in the objective",
    },
  },
  {
    title: { pt: "Materiais Curtidos", en: "Liked Materials" },
    subtitle: {
      pt: "Quantidade de materiais curtidos pelo aluno",
      en: "Number of materials liked by the student",
    },
  },
  {
    title: { pt: "Materiais Pulados", en: "Skipped Materials" },
    subtitle: {
      pt: "Quantidade de materiais pulados pelo aluno",
      en: "Number of materials skipped by the student",
    },
  },
  {
    title: { pt: "Perda de Atenção", en: "Attention Loss" },
    subtitle: {
      pt: "Quantidade de vezes que o aluno perdeu a atenção",
      en: "Number of times the student lost attention",
    },
  },
  {
    title: { pt: "Atenção Habilitada", en: "Attention Enabled" },
    subtitle: {
      pt: "Aluno habilitou para checar a perda de atenção no curso",
      en: "Student enabled to check attention loss during the course",
    },
  },
  {
    title: { pt: "Fora do padrão", en: "Out of Standard" },
    subtitle: {
      pt: "Atributo feito para identificar quando aluno estiver fora do padrão onde é somatório do cálculo = quantidade de materiais curtidos vezes a média do quiz dividido pela quantidade de materiais pulados vezes o tempo de demora de realizar o quiz do objetivo em relação ao quiz antepassado",
      en: "Attribute designed to identify when a student is out of standard where the sum of the calculation = number of liked materials times the quiz average divided by the number of skipped materials times the delay time to complete the objective quiz compared to the previous quiz",
    },
  },
  {
    title: { pt: "Delta de Tempo", en: "Time Delta" },
    subtitle: {
      pt: "Tempo médio de demora de realizar o quiz em relação ao último feito",
      en: "Average delay time to complete the quiz compared to the last one",
    },
  },
  {
    title: { pt: "Quiz Reprovado", en: "Failed Quiz" },
    subtitle: {
      pt: "Número de vezes que o aluno falhou no quiz no curso",
      en: "Number of times the student failed the quiz in the course",
    },
  },
  {
    title: { pt: "Inclinação", en: "Slope" },
    subtitle: {
      pt: "A inclinação(slope) de uma linha representa como os valores do eixo y mudam em comparação aos números no eixo x. Isso também é chamado de taxa de mudança. Onde é pega a média dessas mudanças em relação ao valor do quiz e da data realizada",
      en: "The slope of a line represents how the values on the y-axis change compared to the numbers on the x-axis. This is also called the rate of change. It calculates the average of these changes concerning the quiz value and the date taken",
    },
  },
  {
    title: { pt: "Total de matérias do curso", en: "Total Course Materials" },
    subtitle: {
      pt: "Quantidade total de materiais no curso",
      en: "Total number of materials in the course",
    },
  },
  {
    title: { pt: "Duração total do curso", en: "Total Course Duration" },
    subtitle: {
      pt: "Tempo de duração total no curso",
      en: "Total course duration time",
    },
  },
];
